export const reduceReadBoardsByOrganizationRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingBoards: true },
  };
};

export const reduceReadBoardsByOrganizationSuccess = (
  state,
  { payload: { boardsByOrganization, organizationId } },
) => {
  const allIDs = [];
  const byId = { ...state.base.byId };

  for (let i = 0, len = boardsByOrganization.length; i < len; i += 1) {
    const board = boardsByOrganization[i];

    // using mongoID as key to keep compatibility with other stores like teams
    if (board.mongoId) {
      allIDs.push(board.mongoId);
      byId[board.mongoId] = { ...board };
    }
  }

  // this has the possibility of keeping around old boardIDs in allIDs/byId that were deleted
  // this is to ensure we don't delete keys from other organizations

  return {
    ...state,
    base: {
      ...state.base,
      allIDs: [...new Set([...state.base.allIDs, ...allIDs])].sort(),
      byId,
    },
    byOrganization: {
      ...state.byOrganization,
      [organizationId]: [...allIDs],
    },
    ui: { ...state.ui, isFetchingBoards: false },
  };
};

export const reduceReadBoardsByOrganizationFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingBoards: false },
  };
};
